// extracted by mini-css-extract-plugin
export default {"brandPromo":"QL-z","carousel":"RL-z"};